import type { ElementType, HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

/* Each width reads its --width-* token, so a change in globals.css moves every page. */
const widths = {
    /* Reading width. Long-form prose, legal, blog bodies. */
    prose: 'max-w-(--width-prose)',
    /* Focused width. Single-column forms and flow steps. */
    narrow: 'max-w-(--width-narrow)',
    /* Standard width. Most page content. */
    content: 'max-w-(--width-content)',
    /* Wide width. Galleries and grids. */
    wide: 'max-w-(--width-wide)',
    /* The full container. 1440 with gutters. */
    full: 'max-w-none'
} as const

export type ContainerWidth = keyof typeof widths

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
    as?: ElementType
    width?: ContainerWidth
    children: ReactNode
}

export const Container = ({
    as: Tag = 'div',
    width = 'content',
    className,
    children,
    ...props
}: ContainerProps) => {
    return (
        <div className='container'>
            <Tag className={cn('mx-auto w-full', widths[width], className)} {...props}>
                {children}
            </Tag>
        </div>
    )
}

export default Container
